<template>
    <div class="login-modal">
        <div
            class="form"
        >
            <GenericForm
                :fields="fields"
                @submit="onLoginClick"
            >
                <template slot-scope="slotProps">
                    <CustomInput
                        name="username"
                        ref="username"
                        v-model="fields.username.value"
                        label="username"
                        :errorMessage="slotProps.errors.username"
                        @valueChanged="slotProps.onValueChanged"
                    />
                    <Password
                        name="password"
                        v-model="fields.password.value"
                        label="password"
                        :showStrengthMeter="false"
                        :errorMessage="slotProps.errors.password"
                        :showPasswordVisibilitySwitch="false"
                        @valueChanged="slotProps.onValueChanged"
                    >
                        <template slot="label-sibling">
                            <div
                                @click="onForgotPasswordClick"
                                class="login-modal__forgot-password"
                            >
                                {{ $t('forgot password') | capitalize }}?
                            </div>
                        </template>
                    </Password>
                    <span class="message message--error-big" v-if="displayError">
                        {{ displayError }}
                    </span>
                    <CustomButton
                        :isLoading="isLoading"
                        type="submit"
                        class="btn btn__primary btn--block"
                    >
                        {{ $t('login') | capitalize }}
                    </CustomButton>
                </template>
            </GenericForm>
        </div>
        <div class="login-modal__bottom-links">
            <div>{{ $t('don\'t have account') | capitalize }}?</div>
            <div
                @click="onRegisterClick"
                class="link"
            >
                {{ $t('register') | capitalize }}
            </div>
        </div>
        <div
            class="help-area"
        >
            <button
                @click="showHelp"
                class="btn btn__icon--left"
            >
                <i class="icon icon--sm icon-help_circle btn__icon"/>
                {{ $t("help") | capitalize }}
            </button>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import CustomInput from '@modules/shared/components/forms/CustomInput.vue';
    import ValidationError from '@core/errors/network/ValidationError';
    import { isRequired } from '@modules/shared/validators/forms';
    import { routeNames } from '@app/router';
    import { errorGuard } from '@app/utils';
    import { capitalize } from '@modules/shared/filters';
    import { isMobile } from '@app/layout';

    export default {
        name: 'LoginModal',
        data() {
            return {
                isLoading: false,
                error: '',
                fields: {
                    username: {
                        value: null,
                        validate: [
                            isRequired,
                        ]
                    },
                    password: {
                        value: null,
                        validate: [
                            isRequired,
                        ]
                    },
                },
                asyncErrors: {}
            };
        },
        mounted() {
            this.$refs.username.focusInput();
        },
        watch: {
            user(newValue) {
                if (newValue) {
                    this.closeModal(1);
                }
            }
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user'
            ]),
            displayError() {
                if (this.asyncErrors.nonField) {
                    return capitalize(this.$t(this.asyncErrors.nonField));
                }

                if (this.asyncErrors.message) {
                    return this.asyncErrors.message;
                }

                if (this.error) {
                    return capitalize(this.$t(this.error));
                }

                return null;
            }
        },
        methods: {
            ...mapActions('ui/help', [
                'showHelp',
            ]),
            ...mapActions('data/authentication', [
                'login',
            ]),
            ...mapActions('ui/modal', [
                'setModal',
                'closeModal',
                'closeAllModals',
            ]),
            ...mapActions('ui/help', [
                'reset',
            ]),
            async onLoginClick() {
                this.error = '';
                this.isLoading = true;
                this.asyncErrors = {};
                await errorGuard({
                    action: () => this.login({
                        username: this.fields.username.value,
                        password: this.fields.password.value
                    }),
                    onError: (e) => {
                        if (e instanceof ValidationError) {
                            this.asyncErrors = e.fieldErrors;
                        } else {
                            this.error = 'Something went wrong. Please try again';
                        }
                        if (isMobile()) {
                            // hides the keyboard so the errors are visible
                            document.activeElement.blur();
                        }
                    },
                    showGlobalError: false,
                });
                this.isLoading = false;
            },
            onRegisterClick() {
                this.closeAllModals();
                this.$router.push({ name: routeNames.register });
            },
            onForgotPasswordClick() {
                this.setModal(Modals.forgotPassword.code);
            },
        },
        components: {
            CustomInput,
        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/app/modals/modals/auth/LoginModal.vue